import React from "react";
import PropTypes from "prop-types";
//Material imports
import Typography from "@mui/material/Typography";
import withStyles from "@mui/styles/withStyles";
import Fade from "@mui/material/Fade";
import SlideTitle from "../slide-title/SlideTitle";
const TextSlideBody = ({
  classes,
  slide,
  shouldAnimate
}) => {
  const {
    headline,
    backgroundColor,
    bodyColor,
    headlineColor
  } = slide;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.textSlideContainer,
    style: {
      backgroundColor
    }
  }, /*#__PURE__*/React.createElement(SlideTitle, {
    slide: slide,
    gutterBottom: true
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.headlineTextContainer
  }, /*#__PURE__*/React.createElement(Fade, {
    in: true,
    timeout: 400,
    style: {
      transitionDelay: "0.6s"
    },
    appear: shouldAnimate
  }, /*#__PURE__*/React.createElement(Typography, {
    align: "center",
    className: classes.bodyText,
    component: "span",
    style: {
      color: headlineColor !== null && headlineColor !== void 0 ? headlineColor : bodyColor,
      backgroundColor
    },
    gutterBottom: true
  }, /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: headline
    }
  })))));
};
const styles = {
  textSlideContainer: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    paddingTop: 20,
    marginBottom: 16,
    overflow: "hidden"
  },
  "@media screen and (min-width: 450px)": {
    textSlideContainer: {
      borderTopLeftRadius: 12,
      borderTopRightRadius: 12
    }
  },
  headlineTextContainer: {
    flex: "1",
    display: "flex",
    marginLeft: 20,
    marginRight: 20,
    flexDirection: "column",
    overflow: "hidden"
  },
  bodyText: {
    overflow: "auto"
  }
};
export default withStyles(styles)(TextSlideBody);
TextSlideBody.propTypes = {
  classes: PropTypes.object.isRequired,
  shouldAnimate: PropTypes.bool,
  slide: PropTypes.object.isRequired
};